module.exports = __webpack_public_path__ + "static/media/CERTIFICATE-SEKOLAH-BULANAN-2.dc6d91ab.png";